// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-small-viewport":"(min-width: 768px)","banner":"migration-opt-out_banner__lxwv9"};